import React, { useEffect, useState } from 'react'
import { createAssessmentRecord, fetchAssessments } from '../../../store/actions/assessmentsActions'
import { ERROR } from '../../../store/types'
import { fetchAcademicSessions } from '../../../store/actions/academicSessionsActions'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTerms } from '../../../store/actions/termsActions'
import SelectField from '../../elements/form/SelectField'
import ApplicantTableSnippet from '../applications/ApplicantTableSnippet'
import Loader from '../../elements/Loader'
import NumberField from '../../elements/form/NumberField'
import ModalActionButton from '../../elements/ModalActionButton'

const RecordStudentAssessment = ({student, studentSubjects, close}) => {


    const [recordPayload, setRecordPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})
    
    const dispatch = useDispatch()
    const sessionsSelector = useSelector((state => state.academicSessions))
    const assessmentsSelector = useSelector((state => state.assessments))
    const termsSelector = useSelector((state => state.terms))
    
    useEffect(() => {
        dispatch(fetchAcademicSessions())
        // dispatch(fetchStudents(`currentClass=${subject.classes.map(cl => cl.class._id).join(',')}`, 0, 5))
    
        return () => {
            
        }
    }, [dispatch])

    const [percentageScore, setPercentageScore] = useState(0)
    useEffect(() => {
    
        setPercentageScore(Math.floor((recordPayload.score/recordPayload.outOf) * 100))
        return () => {
            
        }
    }, [recordPayload.score, recordPayload.outOf])
    
    const validateForm = () => {
        let errors = {}

        if(!recordPayload.subject || recordPayload.subject === '') {
            errors.subject = true
        }

        if(!recordPayload.score || recordPayload.score === '' || recordPayload.score < 0) {
            errors.score = true
        }

        if(!recordPayload.outOf || recordPayload.outOf === '' || recordPayload.outOf < 1) {
            errors.outOf = true
        }

        if(!recordPayload.academicSession || recordPayload.academicSession === '') {
            errors.academicSession = true
        }

        if(!recordPayload.term || recordPayload.term === '') {
            errors.term = true
        }

        setValidationErrors(errors)
        return errors
    }

    const pushRecord = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        const payload = {
            ...recordPayload, 
            ...{
                student: student._id,
                percentageScore,
                class: student.class.class._id
            }
        }

        dispatch(createAssessmentRecord(payload))
    }

    const [selectedAssessment, setSelectedAssessment] = useState(null)

    return (
        <>
            <h3 className='text-sm font-[550]'>Find the Student</h3>
            <p className='text-sm text-gray-500'>Search for the student below to record theiir score for this subject</p>
            
             <>
                <div className='flex items-start justify-between my-[10px]'>
                    <ApplicantTableSnippet 
                        applicant={student} 
                        showAdmissionNumber={true} 
                        imageHeightClass='h-[35px]'
                        imageWidthClass='w-[35px]'
                    />
                </div>

                <div className='w-full my-[10px]'>
                    <SelectField
                        selectOptions={studentSubjects}
                        inputLabel="Subject"
                        titleField="name"
                        displayImage={false}
                        imageField=""
                        inputPlaceholder={`Select one of the student's subjects`}
                        requiredField={true}
                        preSelectedIndex={ recordPayload.academicSession ? 
                            studentSubjects?.findIndex(item => 
                            item._id === recordPayload.subject 
                        ) : ''}
                        preSelectedLabel="_id"
                        fieldId="subject-select"
                        hasError={validationErrors && validationErrors.academicSession}
                        disabled={false}
                        // return id of accounts of the selected option
                        returnFieldValue={(value) => {
                            setRecordPayload({...recordPayload, ...{subject: value._id}})
                            dispatch(fetchTerms(`session=${value._id}`), 0, 0)
                        }}
                    />
                </div>

                {sessionsSelector?.loadingSessions ? 
                    <Loader />
                :
                <div className='w-full my-[10px]'>
                    {sessionsSelector?.academicSessions?.academicSessions?.length > 0 ? <SelectField
                        selectOptions={sessionsSelector.academicSessions.academicSessions}
                        inputLabel="Select academic session"
                        titleField="name"
                        displayImage={false}
                        imageField=""
                        requiredField={true}
                        preSelectedIndex={ recordPayload.academicSession ? 
                            sessionsSelector.academicSessions.academicSessions.findIndex(item => 
                            item._id === recordPayload.academicSession 
                        ) : ''}
                        preSelectedLabel="_id"
                        fieldId="fee-select"
                        hasError={validationErrors && validationErrors.academicSession}
                        disabled={false}
                        // return id of accounts of the selected option
                        returnFieldValue={(value) => {
                            setRecordPayload({...recordPayload, ...{academicSession: value._id}})
                            dispatch(fetchTerms(`session=${value._id}`), 0, 0)
                        }}
                    /> 
                    : 
                        <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                            <p>There are no sessions yet. To be able to choose a session for this record, please navigate to "Administration &gt; Academic sessions" on the left sidebar and create one.</p>
                        </div>
                    }
                </div>}

                {recordPayload.academicSession && recordPayload.academicSession !== '' && 
                <>
                    <div className='w-full my-[10px]'>
                        {termsSelector.loadingTerms ? 
                            <Loader />
                        :
                        <>
                            {termsSelector?.terms?.terms?.length > 0 ? 
                                <SelectField
                                    selectOptions={termsSelector?.terms?.terms}
                                    inputLabel="Select term"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    requiredField={true}
                                    preSelectedIndex={ recordPayload?.term ? 
                                        termsSelector?.terms?.terms?.findIndex(item => 
                                        item._id === recordPayload.term 
                                    ) : ''}
                                    preSelectedLabel="_id"
                                    fieldId="term-select"
                                    hasError={validationErrors && validationErrors.term}
                                    disabled={false}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {
                                        setRecordPayload({...recordPayload, ...{term: value._id}})
                                        dispatch(fetchAssessments(`term=${value._id}`, 0, 0))
                                    }}
                                /> 
                            : 
                                <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                                    <p>There are no terms in this session yet. Create a term first to create assessment records</p>
                                </div>
                            }
                        </>
                        }
                    </div>

                    {recordPayload.term && <div className='w-full my-[10px]'>
                        {assessmentsSelector.loadingAssessments ? 
                            <Loader />
                        :
                        <>
                            {assessmentsSelector?.assessments?.assessments?.length > 0 ? 
                                <SelectField
                                    selectOptions={assessmentsSelector?.assessments?.assessments}
                                    inputLabel="Select Assessment"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    requiredField={true}
                                    preSelectedIndex={ recordPayload?.term ? 
                                        assessmentsSelector?.assessments?.assessments?.findIndex(item => 
                                        item._id === recordPayload.assessment 
                                    ) : ''}
                                    preSelectedLabel="_id"
                                    fieldId="term-select"
                                    hasError={validationErrors && validationErrors.assessment}
                                    disabled={false}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {
                                        setRecordPayload({...recordPayload, ...{assessment: value._id}})
                                        setSelectedAssessment(value)
                                    }}
                                /> 
                            : 
                                <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                                    <p>There are no assessments in this term yet. Create an assessment first, to create records.</p>
                                </div>
                            }
                        </>
                        }
                    </div>}

                    <div className='w-full flex items-start justify-between gap-x-[20px]'>
                        <div className='my-[10px] relative w-full'>
                            <NumberField
                                inputType="number" 
                                fieldId={`assessment-score`}
                                inputLabel="Student's assessment score" 
                                requiredField={true}
                                inputPlaceholder={`What the student scored`}
                                preloadValue={recordPayload.score || ''}
                                hasError={validationErrors.score} 
                                returnFieldValue={(value)=>{setRecordPayload({ ...recordPayload, score: value})}}
                            />
                        </div>
                        <div className='my-[10px] relative w-full'>
                            <NumberField
                                inputType="number" 
                                fieldId={`assessment-out-of`}
                                inputLabel="Max assessment score" 
                                inputPlaceholder={`Overall/maximum score`}
                                requiredField={true}
                                preloadValue={selectedAssessment?.totalMarks || recordPayload.outOf || ''}
                                hasError={validationErrors.outOf} 
                                disabled={selectedAssessment?.totalMarks !== undefined}
                                returnFieldValue={(value)=>{setRecordPayload({ ...recordPayload, outOf: value})}}
                            />
                        </div>
                    </div>

                    {recordPayload.score > 0 && recordPayload.outOf > 0 && <div className='p-[10px]'>
                        <p className='text-sm text-gray-400'>Percentage: <span className='font-space-grotesk text-lg text-gray-700 font-medium'>{percentageScore}%</span></p>
                    </div>}
                </>
                }
            </>
            

            {recordPayload.term && recordPayload.term !== '' && <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={'Record Assessment'}
                    buttonAction={()=>{pushRecord()}}
                    processing={assessmentsSelector?.creatingAssessmentRecord}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-xl hover:bg-opacity-10 transition duration-200  hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>}
        </>

    )
}

export default RecordStudentAssessment